import React, {Fragment, useEffect} from 'react';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';
import MdmAccountTable from '../../UI/DataTable/DataTable';
import classes from './MdmMember.css';
import * as Constants from "../../shared/Constants";
import Label from '../../UI/Label/Label';
import {maskSubscr} from '../../shared/utility';

const mdmMember = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const mbrHealthInfo =[], data = props.location.state;
    //console.log("MDM Member : ", props);

    for(let key in data.healthInfoList) {
        mbrHealthInfo.push({
            id:key,
            groupId : data.healthInfoList[key].groupId,
            memberId : data.healthInfoList[key].memberId,
            policyNum : data.healthInfoList[key].policyNum,
            sourceCd : data.healthInfoList[key].sourceCd,
            subscriberId : (maskSubscr(data.healthInfoList[key].subscriberId))
        });
    }

    const memberDemographicInfo = [
        { id: "firstName", labelText: "First Name", labelValue: "" },
        { id: "lastName", labelText: "Last Name", labelValue:"" },
        { id: "address", labelText: "Address", labelValue:"" },
        { id: "suffix", labelText: "Suffix", labelValue:"" },
        { id: "dob", labelText: "Date of Birth", labelValue:"" },
        { id: "gender", labelText: "Gender", labelValue:"" },
        { id: "zip", labelText: "Zip Code", labelValue:"" },
        { id: "phone", labelText: "Phone Number", labelValue:"" },
        { id: "ssn", labelText: "SSN(Last 6 Digits)", labelValue:"" }];

    for(let key in memberDemographicInfo) {
        let id = memberDemographicInfo[key].id;
        if(id !== "ssn") {
            memberDemographicInfo[key].labelValue = data[id];
        } else {
            memberDemographicInfo[key].labelValue = maskSubscr(data[id]);
        }
    }

    const resultColumnMapping = [
        {dataField: 'groupId', text: 'Group ID'},
        {dataField: 'subscriberId', text: 'Subscriber ID', title: true},
        {dataField: 'policyNum', text: 'Policy/Group#'},
        {dataField: 'memberId', text: 'Member ID'},
        {dataField: 'sourceCd', text: 'Source Code', sort: true}
    ];

     let mdmDetailedInfo = (
        <div className={classes.MdmMember}>
           {memberDemographicInfo.map(formElement => (
           <div style={{width:'30%'}} key={formElement.id}>
            <Label
                   labelText = {formElement.labelText}
                   labelValue = {formElement.labelValue}
                   displayType = "true"
            />
            </div>
            ))}
        </div>
     );

    let form = null;
    if(props.location.state && data) {
        // form when there is member data is available
        form = (
            <Fragment>
                <DisplayBox>
                    <div>
                        <h2 className={classes.FormTitle}>{Constants.MDM_ACCOUNT}</h2>
                    </div>
                    <br/>
                    {mdmDetailedInfo}
                    <MdmAccountTable
                        title=""
                        data={mbrHealthInfo}
                        columns={resultColumnMapping}
                        clicked={(data)=>{}}
                    />
                </DisplayBox>
            </Fragment>
        );
    }
    return form ;
}

export default mdmMember;